import { render, staticRenderFns } from "./InsertWells.vue?vue&type=template&id=d17998da&scoped=true&"
import script from "./InsertWells.vue?vue&type=script&lang=js&"
export * from "./InsertWells.vue?vue&type=script&lang=js&"
import style0 from "./InsertWells.vue?vue&type=style&index=0&id=d17998da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17998da",
  null
  
)

export default component.exports